
<div [ngClass]="[ (showPopup && !startHiding) ? 'popup-level-' + openedPopupsCount : 'hideField',(showPopup && !startHiding) ? 'show-field-' + popupStyle : '', isFullScreenPopUp ? 'fieldContainer-full-screen' : 'fieldContainer' ]">

<div [ngClass]="{'background' : showPopup}"></div>
<div *ngIf="showPopup">
        <div
        [ngClass]="[(showRoundedCorner && !isFullScreenPopUp) ? 'round-corner': '', isActivePopup() ?  'popup-header-select' : 'popup-header-deselect', isFullScreenPopUp ? 'left-title-bar-full-screen' : 'left-title-bar']"><span class="vertical-text">{{popUpTitle | translate}}</span></div>
        <div [ngClass]="[(showRoundedCorner && !isFullScreenPopUp) ? 'round-corner': '', isFullScreenPopUp ? 'main-modal-full-screen' : 'main-modal']">
                <div [ngClass]="'header-'+popupStyle"> 
                        <div class="head-title">
                        </div>
                        <span></span>
                        <div class="tabs">
                                <span><button type="button" [ngClass]="{'tab-btn-disable': isMultiMediaUploadOpen}"
                                                style="border-top-left-radius: 8px;"
                                                class="btn btn-tab element-over-hand"
                                                (click)="openEditUploadTab()">{{"lbl_select_from_gallery" | translate}}</button></span>
                                <span><button type="button" [ngClass]="{'tab-btn-disable': !isMultiMediaUploadOpen}"
                                                style="border-top-right-radius: 8px;" class="btn btn-tab"
                                                (click)="openEditUploadTab()">{{"lbl_new_edit" | translate}}</button></span>                                
                        </div>
                </div>
                <div class="body">
                        <!-- image lazy loading -->
                        <div [ngClass]="'page-title-'+popupStyle">{{addTitle}}</div>
                        <app-mainlazyloading [displayList]="lazyLoadingDisplayImageItems"
                                [defaultItemIds]="selectedImages"
                                [filterTypes] = "filterTypes"
                                [isFullScreenPopUp] = "isFullScreenPopUp"
                                [defaultImageType]="resourceType"
                                [popupWidth]="popupWidth"
                                [deleteItemId]="deleteMediaId"
                                (selectedItem)="selectedImage($event)"
                                (editItem)="editImage($event)"
                                (reload)="reload($event)"
                                (deleteItem)="deleteMedia($event)"                                
                                >
                        </app-mainlazyloading>

                        <!-- image edit and upload -->
                        <app-multimediaupload [ngClass]="{'showUpload' : isMultiMediaUploadOpen}"
                                [title]="editTitle" [titleBelongs]="titleBelongsTo" [cropFrameMode]="cropFrameMode" [acceptedMultimediaTypes] = "acceptedMultimediaTypes" class="upload-container"
                                [editMultimediaBasicInfo]="editMultimedia" (clearEditingMultimedia)="clearEditingMultimedia($event)"
                                [isFullScreenPopUp] = "isFullScreenPopUp"
                                [popupWidth]="popupWidth"
                                (changeTab)="changeTabAndRefresh()">
                        </app-multimediaupload>
                </div>
                <div class = "footer">
                        <div [ngClass]="'buttons-'+popupStyle">
                          <span class="selected-file" *ngIf="isSaveEnable && !imageDeselected">
                            {{"lbl_you_have_selected" | translate}}
                            {{selectedImageCaption}}<span class="btn-check">
                              <img src="assets/input-form/btn-ok.png">
                            </span>
                          </span>
                                <span><button *ngIf="!isFullScreenPopUp" type="button" class="btn btn-primary  btn-foot"
                                        [ngClass]="(isSaveEnable)?'btn-active' : 'btn-disable'" (click)="selected()" [disabled]="!isSaveEnable">{{"lbl_save" | translate}}</button></span>
                                <span><button *ngIf="!isFullScreenPopUp" type="button" class="btn btn-primary btn-foot btn-cancel element-over-hand"
                                        (click)="cancel()">{{"lbl_cancel" | translate }}</button></span>
                        </div>
                </div>
        </div>
</div>
         
</div>
